import { useState } from "react";
import { Accordion, type AccordionProps } from "../Accordion";

export type AccordionToggleProps = Omit<AccordionProps, "isOpened"> & {
  defaultIsOpened?: boolean;
  ariaLabelPrefix?: string;
};

export const AccordionToggle = (props: AccordionToggleProps) => {
  const { children, onClick, defaultIsOpened, ariaLabelPrefix, ...rest } = props;

  const [isOpened, setIsOpened] = useState(defaultIsOpened ?? false);

  const handleClick = () => {
    setIsOpened((prev) => !prev);
    onClick?.();
  };

  return (
    <Accordion
      ariaLabelPrefix={ariaLabelPrefix}
      isOpened={isOpened}
      onClick={handleClick}
      {...rest}
    >
      {children}
    </Accordion>
  );
};
